import { cssVarColors, cssVarTextColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'
import { onHoverStyle } from '../../../style/style'
const { contentBg } = cssVarColors

export const sheet: Styles = {
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: contentBg,
    borderRadius: '14.25px',
    boxShadow: '0px 8.91px 13.36px -2.67px #0000001A, 0px 3.56px 5.35px -3.56px #0000001A'
  },
  hoverRoot: {
    cursor: 'pointer',
    ...onHoverStyle.base,
    '&:hover': {
      ...onHoverStyle.active
    }
  },
  rootXs: {
    padding: '12px 12px'
  },
  rootSm: {
    padding: '12px 32px'
  },
  rootDefault: {
    padding: '24px 32px'
  },

  overflow: {
    overflow: 'auto'
  },

  '@media (max-width: 800px)': {
    rootSm: {
      padding: '10px 16px'
    },
    rootDefault: {
      padding: '12px 16px'
    }
  },

  '@media (max-width: 400px)': {
    rootSm: {
      padding: '8px 10px'
    },
    rootDefault: {
      padding: '8px 10px'
    }
  },

  rootNoPaddings: {
    padding: 0
  },
  topContainer: {
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  topContainerPadding: {
    marginBottom: '20px'
  },
  row: {
    flexDirection: 'row'
  }
}
